module.exports = __webpack_public_path__ + "media/images/color_admin_v3/gallery/gallery-1-88e5776a6dfbb2e1ddf747195f3dfdc3.jpg";